var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Buying_Icon",
    "data-name": "Buying Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 50,
    height: 48,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M177,29.66a3.5,3.5,0,1,1-3.5-3.5,3.5,3.5,0,0,1,3.5,3.5",
    transform: "translate(-136 -20.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M177,182.34a3.5,3.5,0,1,1-3.5-3.5,3.5,3.5,0,0,1,3.5,3.5",
    transform: "translate(-136 -143.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M5.529,106.415l-.927.178-4.6.884v11.006H13.546c2.905,0,5.153-3.22,6.64-5.351.31-.444.6-.863.873-1.214a80.51,80.51,0,0,1,6.819-7.268l.805-.792c.237-.234.48-.466.716-.69,2.522-2.405,2.581-2.9,1.734-3.947-.6-.75-1.012-.75-1.208-.75a6.585,6.585,0,0,0-2.471.934c-.207.108-.41.214-.608.313-.622.312-3.775,2.351-5.815,3.7l-4.1,2.712,1.045-4.805.953-4.38.02-.09.028-.088c.417-1.316,1.789-2.232,3.787-3.072a.4.4,0,0,0,.247-.37L23,88.5a.4.4,0,0,0-.524-.379c-3.787,1.239-7.423,2.509-8.539,3.039-1.018,1.754-5.281,9.526-7.952,14.423Z",
    transform: "translate(0 -70.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M125.4,0a.4.4,0,0,0-.4.4V19.609l.013,4.877-.013,0V28c.42-.257.758-.456.95-.552.325-.163.663-.344,1.01-.522V1.96H148.04V46.04H126.96V37.892c-.657.662-1.322,1.348-1.96,2.033V47.6a.4.4,0,0,0,.4.4h24.2a.4.4,0,0,0,.4-.4V.4a.4.4,0,0,0-.4-.4Z",
    transform: "translate(-100)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M154.059,141.939a8.013,8.013,0,0,0,.7.912,2.959,2.959,0,0,0-.376-.562,3.323,3.323,0,0,0-.321-.35",
    transform: "translate(-123.247 -113.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M155.5,80a8.007,8.007,0,0,0-7.749,9.995c.058,0,.116-.006.174-.006a3.456,3.456,0,0,1,2.766,1.5,3.233,3.233,0,0,1,.722,3.393A8,8,0,1,0,155.5,80",
    transform: "translate(-118 -64)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuying);
export default __webpack_public_path__ + "static/media/buying.282dc3ff60fa031ae03eb56e726116f8.svg";
export { ForwardRef as ReactComponent };